import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SydAutocomplete from '../../../../commonDesign/SydAutocomplete'
import { useListViewTags } from '../../../../../api/abundanceEngine'
import useDebouncedValue from '../../../../../hooks/useDebounceValue'

function ViewTagsAutocomplete ({
  onChange
}) {
  const [searchText, setSearchText] = useState('')
  const debouncedText = useDebouncedValue(searchText, 200)

  const { data, isLoading } = useListViewTags({
    sort: [{ field: 'name', dir: 'asc' }],
    limit: 10,
    filters: debouncedText ? {
      search: [{ op: 'contains', value: debouncedText }]
    } : undefined
  })

  return (
    <>
      <SydAutocomplete
        options={data?.map(tag => ({ label: tag.displayName, subLabel: tag.description, value: tag.viewTagId }))}
        onChange={(e, val) => onChange?.(val)}
        onInputChange={(_, value) => setSearchText(value)}
        placeholder='Filter by tag'
        disabled={!data?.length}
        size='sm'
        isLoading={isLoading}
        multiple
      />
    </>
  )
}

ViewTagsAutocomplete.propTypes = {
  onChange: PropTypes.func
}

export default ViewTagsAutocomplete
